import NavBar from './component';
import enhance from './container';

export default enhance(NavBar);
